import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { AuthenticationConfiguration } from '../authentication-configuration.model';
import { URL_BASE } from '../../core/constants';
import { HttpUtils } from '../http-utils';

@Injectable()
export class AuthenticationConfigurationService {

  private baseUrl = '/api/authentication/public/configuration';

  constructor(private http: HttpClient, private handler: HttpBackend) {}

  public loadConfiguration(): Promise<AuthenticationConfiguration> {
    const headers = HttpUtils.createHeadersWithoutAuthorization();
    this.http = new HttpClient(this.handler);
    return this.http.get<AuthenticationConfiguration>(`${URL_BASE}${this.baseUrl}`, { headers })
      .toPromise();
  }
}
